/**
 * Announcement Bar - Klaviyo Popup Integration
 * Opens Klaviyo popup when clicking on announcement bar text
 * Popup IDs are configured in the section settings
 */

document.addEventListener('DOMContentLoaded', function() {
  // Get the announcement bar container
  const announcementBar = document.querySelector('.announcement-bar');
  
  if (!announcementBar) return;

  // Get the popup IDs from data attributes
  const desktopPopupId = announcementBar.dataset.klaviyoDesktopId;
  const mobilePopupId = announcementBar.dataset.klaviyoMobileId;

  // Check if IDs are configured
  if (!desktopPopupId || !mobilePopupId) {
    console.warn('Klaviyo popup IDs are not configured in the announcement bar settings');
    return;
  }

  // Get all clickable announcement bar texts
  const announcementTexts = document.querySelectorAll('.announcement-bar__text--clickable');
  
  if (announcementTexts.length === 0) return;

  announcementTexts.forEach(function(text) {
    text.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Check if Klaviyo is loaded
      if (typeof window._klOnsite === 'undefined') {
        console.warn('Klaviyo is not loaded yet');
        return;
      }

      // Determine which popup to show based on screen width
      const isDesktop = window.innerWidth >= 1024;
      const popupId = isDesktop ? desktopPopupId : mobilePopupId;

      // Open the Klaviyo popup
      try {
        window._klOnsite.push(['openForm', popupId]);
      } catch (error) {
        console.error('Error opening Klaviyo popup:', error);
      }
    });
  });
});

